import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div``;

export const Title = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('bold120_B2')};
`;

export const Contents = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
`;

export const ChartSectionWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0 40px;

  position: relative;
  padding: 40px 0;

  ${({ theme }) => theme.media.tablet} {
    justify-content: space-between;
    padding-left: 22px;
    padding-right: 22px;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }
`;

export const ChartSection = styled.div`
  flex: 0 0 280px;
  text-align: center;

  ${({ theme }) => theme.media.mobile} {
    flex: 0 0 auto;
    margin-bottom: 40px;
    padding: 0 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Subject = styled.div`
  color: ${({ theme }) => theme.colors.gray900};
  text-align: center;
  ${getFontStyle('midium150_B3')};
  font-weight: 500;
`;
